import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  Checkbox, TextField,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Button,
  Input,
  Label,
} from '@ipc/ipc-components';
import { Autocomplete } from '@material-ui/lab';
import {
  getAllDataLocationsList,
  getAllImpcLocationsList,
  getIsContactDetailLoading,
  getContactDetail, isEmailAddressDuplicate,
} from '../../redux/selectors/MrdContactsSelectors';
import { getUserRole } from '../../../../../common/user/redux/selectors/UserSelectors';
import {
  getAllDataLocationsRequestActionCreator,
  getAllImpcLocationsRequestActionCreator,
  getContactDetailsRequestActionCreator,
  checkEmailAddressRequestActionCreator,
  clearEmailDuplicateActionCreator,
} from '../../redux/actions/ContactsActions';
import { EditContactDialogStyles } from './EditContactDialog.styles';
import { formatMessage } from '../../../../../../locales/locales';

function EditContactDialog(props) {
  const {
    isOpen,
    userRole,
    impcLocationList,
    dataLocationList,
    closeDialog,
    getDataLocationList,
    getImpcLocationList,
    confirmHandle,
    selectedImpc,
    selectedContact,
    contactDetail,
    isContactDetailLoading,
    getContactDetailRequest,
    checkEmailAddress,
    isEmailDuplicate,
    clearEmailDuplicate,
  } = props;

  useEffect(() => {
    getImpcLocationList();
    if (userRole === 'IPC_ADMIN') {
      getDataLocationList();
    }
  }, []);
  const [email, setEmail] = useState(null);
  const [enteredFirstName, setFirstName] = useState(null);
  const [enteredLastName, setLastName] = useState(null);
  const [phone, setPhone] = useState(null);
  const [notifyForFailure, setNotifyForFailure] = useState(false);
  const [impcLocation, setImpcLocations] = useState(selectedImpc !== null && selectedImpc !== undefined ? [{ inputValue: selectedImpc, title: selectedImpc }] : []);
  const [isIpcContact, setIsIpcContact] = useState(userRole.includes('IPC') || false);
  const [dataLocation, setDataLocations] = useState([]);
  const [emailError, setEmailError] = useState(false);
  const [isFormValid, updateFormValidity] = useState(false);
  const [defaultImpcList, setDefaultImpcList] = useState([]);

  useEffect(() => {
    if (selectedContact) {
      getContactDetailRequest({
        contactId: selectedContact.id,
      });
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isContactDetailLoading && contactDetail !== null) {
      if (contactDetail.impcLocations !== undefined && Array.isArray(contactDetail.impcLocations)) {
        const currentImpcLocations = contactDetail.impcLocations.map((item) => ({ inputValue: item, title: item }));
        setImpcLocations(currentImpcLocations);
        if (userRole === 'OPER_ADMIN') {
          setDefaultImpcList(currentImpcLocations);
        }
      }
      setEmail(contactDetail.emailAddress);
      setFirstName(contactDetail.firstName);
      setLastName(contactDetail.lastName);
      setPhone(contactDetail.phoneNumber);
      setNotifyForFailure(contactDetail.notifyOnFailure);
      setIsIpcContact(contactDetail.ipcContact);
      if (contactDetail.dataLocations !== undefined && Array.isArray(contactDetail.dataLocations)) {
        setDataLocations(contactDetail.dataLocations.map((element) => ({
          inputValue: element.id,
          title: element.dataLocation,
        })));
      }
    }
  }, [isContactDetailLoading]);

  useEffect(() => {
    updateFormValidity(!(enteredFirstName === null
      || (email !== undefined && !email.includes('@'))
      || (email !== undefined && !email.includes('.'))
      || (email !== undefined && email.includes(' '))
      || enteredLastName === null
      || emailError
      || (!isIpcContact && (impcLocation.length === 0 && dataLocation.length === 0))
      || (!userRole.includes('IPC') && impcLocation.length === 0)
      || isContactDetailLoading
      || isEmailDuplicate
    ));
  }, [enteredFirstName, enteredLastName, email, emailError, impcLocation, dataLocation, isContactDetailLoading, isEmailDuplicate, isIpcContact]);
  useEffect(() => {
    if (email !== null && email !== undefined) {
      const isEmailValid = email.includes('@') && email.includes('.') && (email.indexOf('@') > 0) && (!email.endsWith('.')) && !(email.includes(' '));
      if (isEmailValid && email !== selectedContact.emailAddress) {
        checkEmailAddress({ email });
      }
      if (isEmailDuplicate && email === selectedContact.emailAddress) {
        clearEmailDuplicate();
      }
      setEmailError(!isEmailValid);
    }
  }, [email]);

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleFirstName = (e) => {
    if (e.target.value === '') {
      setFirstName(null);
    } else {
      setFirstName(e.target.value);
    }
  };

  const handleLastName = (e) => {
    if (e.target.value === '') {
      setLastName(null);
    } else {
      setLastName(e.target.value);
    }
  };

  const handlePhone = (e) => {
    setPhone(e.target.value);
  };

  const phoneKeyPress = (e) => {
    const phoneRegex = /[0-9\d\s-+/()\\\][]/g;
    if (!phoneRegex.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleNotifyForFailure = (e) => {
    setNotifyForFailure(e.target.checked);
  };

  const handleImpcLocation = (event, inputValue) => {
    if (defaultImpcList.length > 0) {
      const deletedItems = defaultImpcList.filter((item) => !inputValue.find((inputItem) => item.inputValue === inputItem.inputValue));
      setImpcLocations([...deletedItems, ...inputValue]);
    } else {
      setImpcLocations(inputValue);
    }
  };

  const handleIsIpcContact = (e) => {
    setIsIpcContact(e.target.checked);
  };

  const handleDataLocation = (event, inputValue) => {
    setDataLocations(inputValue);
  };

  const confirmSave = () => {
    const impcLoc = impcLocation.map((impc) => impc.inputValue);
    const dataLoc = dataLocation.map((data) => data.inputValue);
    const requestData = {
      contactId: selectedContact.id,
      data: {
        dataLocations: dataLoc,
        emailAddress: email,
        firstName: enteredFirstName,
        impcLocations: impcLoc,
        ipcContact: isIpcContact,
        lastName: enteredLastName,
        notifyOnFailure: notifyForFailure,
        phoneNumber: phone,
      },

    };
    clearEmailDuplicate();
    confirmHandle(requestData);
  };

  const handleCloseDialog = () => {
    clearEmailDuplicate();
    setEmail(null);
    setFirstName(null);
    setLastName(null);
    setPhone(null);
    setNotifyForFailure(null);
    setIsIpcContact(null);
    setDataLocations([]);
    setImpcLocations([]);
    closeDialog();
  };
  return (
    <Dialog onClose={handleCloseDialog} aria-labelledby="simple-dialog-title" open={isOpen}>
      <EditContactDialogStyles>
        <DialogTitle id="simple-dialog-title">Edit Contact</DialogTitle>
        <div>
          <table className="contact-form-details">
            <tbody>
              <tr>
                <td className="contact-form-input-details">
                  <Label>Email</Label>
                </td>
                <td className="contact-form-input-details">
                  <Input
                    type="text"
                    value={email}
                    maxLength={45}
                    required
                    onChange={handleEmail}
                    size={45}
                    placeholder="example@example.com"
                    inputProps={{ mask: 'x@x.x' }}
                  />
                </td>
                {isEmailDuplicate && (
                  <td className="contact-form-input-details" style={{ color: 'red', minWidth: '210px' }}>
                    This email address is not unique.
                  </td>
                )}
              </tr>
              {emailError && (
                <tr>
                  <td />
                  <td className="contact-form-input-details" style={{ color: 'red' }}>Please enter a valid e-mail address</td>
                </tr>
              )}
              <tr>
                <td className="contact-form-input-details">
                  <Label>First name</Label>
                </td>
                <td className="contact-form-input-details">
                  <Input
                    type="text"
                    value={enteredFirstName}
                    maxLength={30}
                    size={45}
                    onChange={handleFirstName}
                  />
                </td>
              </tr>
              <tr>
                <td className="contact-form-input-details">
                  <Label>Last name</Label>
                </td>
                <td className="contact-form-input-details">
                  <Input
                    type="text"
                    value={enteredLastName}
                    maxLength={30}
                    size={45}
                    onChange={handleLastName}
                  />
                </td>
              </tr>
              <tr>
                <td className="contact-form-input-details">
                  <Label>Phone</Label>
                </td>
                <td className="contact-form-input-details">
                  <Input
                    type="tel"
                    value={phone}
                    maxLength={20}
                    size={45}
                    onChange={handlePhone}
                    onKeyPress={(e) => phoneKeyPress(e)}
                  />
                </td>
              </tr>
              <tr>
                <td className="contact-form-input-details">
                  <Label>Notify for failure</Label>
                </td>
                <td className="contact-form-input-details">
                  <Checkbox
                    checked={notifyForFailure}
                    onChange={handleNotifyForFailure}
                  />
                </td>
              </tr>
              <tr>
                <td className="contact-form-input-details">
                  <Label>IMPC Locations</Label>
                </td>
                <td className="contact-form-input-details">
                  <Autocomplete
                    multiple
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="tags-outlined"
                    value={impcLocation}
                    onChange={handleImpcLocation}
                    filterSelectedOptions
                    getOptionSelected={(option, value) => option.title === value.title}
                    defaultValue={impcLocation.length === 1 ? [impcLocation[0]] : null}
                    options={impcLocationList.map((element) => ({
                      inputValue: element.impc,
                      title: element.impc,
                    }))}
                    getOptionLabel={(option) => option.title}
                    size="small"
                    disableClearable={userRole === 'OPER_ADMIN'}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                      />
                    )}
                  />
                </td>
              </tr>
              { userRole === 'OPER_ADMIN' && (
                <tr>
                  <td />
                  <td>
                    <div className="info-message">
                      <span>
                        {formatMessage('en', 'contact.edit.operator.admin.info.message')}
                      </span>
                    </div>
                  </td>
                </tr>
              )}

              {userRole.includes('IPC') && (
                <tr>
                  <td className="contact-form-input-details">
                    <Label>
                      IPC Contact
                    </Label>
                  </td>
                  <td className="contact-form-input-details">
                    <Checkbox
                      checked={isIpcContact}
                      onChange={handleIsIpcContact}
                    />
                  </td>
                </tr>
              )}
              {userRole.includes('IPC') && (
                <tr>
                  <td className="contact-form-input-details">
                    <Label>
                      Data Locations
                    </Label>
                  </td>
                  <td className="contact-form-input-details">
                    <Autocomplete
                      multiple
                      id="tags-outlined"
                      selectOnFocus
                      clearOnBlur
                      handleHomeEndKeys
                      value={dataLocation}
                      getOptionSelected={(option, value) => option.title === value.title}
                      onChange={handleDataLocation}
                      filterSelectedOptions
                      size="small"
                      options={dataLocationList.map((element) => ({
                        inputValue: element.id,
                        title: element.dataLocation,
                      }))}
                      getOptionLabel={(option) => option.title}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                        />
                      )}
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button className="cancel" onClick={handleCloseDialog}>Cancel</Button>
          <Button
            className={`primary-button-${!isFormValid} action`}
            disabled={!isFormValid}
            id="save"
            onClick={confirmSave}
          >
            Save
          </Button>
        </div>
      </EditContactDialogStyles>
    </Dialog>
  );
}
function mapStateToProps(state) {
  return {
    impcLocationList: getAllImpcLocationsList(state),
    dataLocationList: getAllDataLocationsList(state),
    userRole: getUserRole(state),
    isContactDetailLoading: getIsContactDetailLoading(state),
    contactDetail: getContactDetail(state),
    isEmailDuplicate: isEmailAddressDuplicate(state),
  };
}
EditContactDialog.propTypes = {
  isOpen: PropTypes.bool,
  userRole: PropTypes.string,
  impcLocationList: PropTypes.arrayOf(PropTypes.object),
  dataLocationList: PropTypes.arrayOf(PropTypes.object),
  allContacts: PropTypes.arrayOf(PropTypes.object),
  closeDialog: PropTypes.func.isRequired,
  getDataLocationList: PropTypes.func,
  getImpcLocationList: PropTypes.func,
  confirmHandle: PropTypes.func,
  selectedImpc: PropTypes.string,
  checkEmailAddress: PropTypes.func,
  isEmailDuplicate: PropTypes.number,
  selectedContact: PropTypes.objectOf(PropTypes.object),
  getContactDetailRequest: PropTypes.func,
  isContactDetailLoading: PropTypes.bool,
  contactDetail: PropTypes.objectOf(PropTypes.object),
  clearEmailDuplicate: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getDataLocationList: getAllDataLocationsRequestActionCreator,
  getImpcLocationList: getAllImpcLocationsRequestActionCreator,
  checkEmailAddress: checkEmailAddressRequestActionCreator,
  getContactDetailRequest: getContactDetailsRequestActionCreator,
  clearEmailDuplicate: clearEmailDuplicateActionCreator,
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EditContactDialog);
